import { useAuth } from "@roastery/auth";
import { useTranslation } from "@roastery/i18n";
import { Button } from "@roastery/ui";
import { createFileRoute } from "@tanstack/react-router";
import { FullScreenMessage } from "../components/full-screen-message";
import { usePublicBranding } from "../lib/branding";

/**
 * Where signing out lands (US-23.6).
 *
 * <p>Outside `_authed` on purpose: the whole point is that it does not ask for a token, and a page
 * behind the gate would have sent the person who just signed out straight back to a login screen —
 * which is what the portal used to do, and it read as if signing out had not worked.
 *
 * <p>The roastery's own name and logo are still here: the branding call needs no token, and a café
 * that has just closed its supplier's portal should see whose portal it was.
 */
export const Route = createFileRoute("/signed-out")({
  component: SignedOut,
});

function SignedOut() {
  const { t } = useTranslation();
  const auth = useAuth();
  const branding = usePublicBranding();

  return (
    <FullScreenMessage
      testId="portal-signed-out"
      title={t("auth.signedOut.title")}
      description={t("auth.signedOut.description")}
      roastery={{ name: branding.data?.name, logoUrl: branding.data?.logoUrl }}
      action={
        <Button data-testid="portal-sign-in-again" onClick={() => void auth.signinRedirect()}>
          {t("auth.signedOut.signInAgain")}
        </Button>
      }
    />
  );
}
